import React, { memo } from 'react';
export var Plus = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#FFA06A' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.6 22.6",
    style: {
      enableBackground: 'new 0 0 22.6 22.6'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: color,
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "11.3",
    y1: "1",
    x2: "11.3",
    y2: "21.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: color,
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "1",
    y1: "11.3",
    x2: "21.5",
    y2: "11.3"
  }));
});